module.exports = __webpack_public_path__ + "fonts/GothamRegular.80d5397d.otf";